import {EmptyString, isNonEmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import {Password, UnvalidatedPassword, ValidPassword} from 'Core/models/Password';
import unionize, {ofType, UnionOf} from 'unionize';

export type InvalidPasswordResetForm = {
  answerOne: StringUnion;
  answerTwo: StringUnion;
  password: Password;
};

export type ValidPasswordResetForm = {
  answerOne: NonEmptyString;
  answerTwo: NonEmptyString;
  password: ValidPassword;
  errorMessage?: string;
};

export const PasswordResetForm = unionize({
  Unvalidated: ofType<InvalidPasswordResetForm>(),
  Invalid: ofType<InvalidPasswordResetForm>(),
  Valid: ofType<ValidPasswordResetForm>(),
  FailureToUpdate: ofType<ValidPasswordResetForm>(),
});

export const PasswordUpdate = unionize({
  Entry: ofType<{form: PasswordResetForm}>(),
  Saving: ofType<{}>(),
  Complete: ofType<{}>(),
});

export type PasswordUpdate = UnionOf<typeof PasswordUpdate>;

export const validatePasswordResetForm = (passwordResetForm: PasswordResetForm) => {
  const {answerOne, answerTwo, password} = passwordResetForm;

  return isNonEmptyString(answerOne) && isNonEmptyString(answerTwo) && password instanceof ValidPassword
    ? PasswordResetForm.Valid({
        answerOne,
        answerTwo,
        password,
      })
    : PasswordResetForm.Invalid({
        answerOne,
        answerTwo,
        password,
      });
};

export type PasswordResetForm = UnionOf<typeof PasswordResetForm>;

export const EmptyPasswordResetForm: PasswordResetForm = PasswordResetForm.Unvalidated({
  answerOne: new EmptyString(),
  answerTwo: new EmptyString(),
  password: new UnvalidatedPassword('', ''),
});
